import agreementsComponent from './agreements.component';

const agreementsModule = angular
  .module('agreements', [])
  .component('agreements', agreementsComponent);

export default agreementsModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/agreements/agreements.js
 **/